import { formatDateInMonthAndYear } from 'wisestep-base';

import { IHeatMapDataType, ISeriesDataType } from '../types';

export const getAllDataPoints = (aggregatedData): string[] => {
  const dataPoints: string[] = [];
  if (aggregatedData) {
    aggregatedData.forEach((item) => {
      item.aggregation?.buckets?.forEach((subItem) => {
        if (subItem.key_as_string && dataPoints.indexOf(subItem.key_as_string) == -1) {
          dataPoints.push(subItem.key_as_string);
        }
      });
    });
  }
  dataPoints.sort();
  return dataPoints;
};

export const getFirstLevelKeys = (aggregatedData): string[] => {
  const dataPoints: string[] = [];
  if (aggregatedData) {
    aggregatedData.forEach((item) => {
      dataPoints.push(item.key);
    });
  }
  dataPoints.sort();
  return Array.from(new Set(dataPoints));
};

export const getSecondLevelKeys = (aggregatedData): string[] => {
  const dataPoints: string[] = [];
  if (aggregatedData) {
    aggregatedData.forEach((item) => {
      item.aggregation?.buckets?.forEach((subItem) => {
        if (subItem.key && dataPoints.indexOf(subItem.key) == -1) {
          dataPoints.push(subItem.key);
        }
      });
    });
  }
  dataPoints.sort();
  return dataPoints;
};

export const getData = (items, dataPoints): ISeriesDataType[] => {
  const returnArr: ISeriesDataType[] = [];
  if (dataPoints) {
    dataPoints.forEach((dataPoint) => {
      let exists = false;
      items.forEach((item) => {
        if (item?.key_as_string == dataPoint) {
          exists = true;
          returnArr.push({ x: item.key_as_string, y: item.doc_count });
        }
      });
      if (!exists) {
        returnArr.push({ x: dataPoint, y: 0 });
      }
    });
  }

  return returnArr;
};

export const getHeatMapFormattedData = (aggregatedData, dataPoints) => {
  const bucketData: IHeatMapDataType[] = [];
  aggregatedData.forEach((item) => {
    bucketData.push({ name: item.key, data: getData(item.aggregation?.buckets, dataPoints) });
  });
  return bucketData;
};

export const getKeys = (aggregatedData): string[] => {
  const dataPoints: string[] = [];
  aggregatedData &&
    aggregatedData.forEach((item) => {
      item.aggregation?.buckets?.forEach((subItem) => {
        if (subItem.key && dataPoints.indexOf(subItem.key) == -1) {
          dataPoints.push(subItem.key);
        }
      });
    });
  return dataPoints;
};

export const getFormattedDataOfKeyAsString = (aggregatedData, dataPoints) => {
  const bucketData: IHeatMapDataType[] = [];
  aggregatedData.forEach((item) => {
    bucketData.push({
      name: formatDateInMonthAndYear(item.key_as_string ?? ''),
      data: getDataByKeys(item.aggregation?.buckets, dataPoints),
    });
  });
  return bucketData;
};

export const getDataByKeys = (items, dataPoints): ISeriesDataType[] => {
  const returnArr: ISeriesDataType[] = [];
  if (dataPoints) {
    dataPoints.forEach((dataPoint) => {
      let exists = false;
      items.forEach((item) => {
        if (item?.key == dataPoint) {
          exists = true;
          returnArr.push({ x: item.key, y: item.doc_count });
        }
      });
      if (!exists) {
        returnArr.push({ x: dataPoint, y: 0 });
      }
    });
  }

  return returnArr;
};

export const getDataPoints = (aggregatedData, keyData) => {
  const returnArr: ISeriesDataType[] = [];
  const dataPoints = getFirstLevelKeys(aggregatedData);
  const keyArr: string[] = [];
  const keyVal: number[] = [];
  const tempArr: string[] = [];
  aggregatedData.map((data) => {
    data.aggregation.buckets.forEach((buc1) => {
      if (buc1.key == keyData) {
        dataPoints.forEach((dataPoint) => {
          if (data?.key == dataPoint) {
            keyArr.push(data.key);
            keyVal.push(buc1.doc_count);
          }
        });
      }
    });
  });

  dataPoints.map((dataPoint) => {
    keyArr.map((arr, ind) => {
      if (!keyArr.includes(dataPoint) && !tempArr.includes(dataPoint) && arr != dataPoint) {
        tempArr.push(dataPoint);
        returnArr.push({ x: dataPoint, y: 0 });
      } else if (!tempArr.includes(dataPoint) && arr == dataPoint) {
        tempArr.push(dataPoint);
        returnArr.push({ x: arr, y: keyVal[ind] });
      }
    });
  });
  return returnArr;
};

export const makingDataPoints = (aggregatedData) => {
  const bucketData: IHeatMapDataType[] = [];
  getSecondLevelKeys(aggregatedData)
    .reverse()
    .map((keyData) => {
      bucketData.push({
        name: keyData,
        data: getDataPoints(aggregatedData, keyData),
      });
    });
  return bucketData;
};
